import { memo } from 'react';
import {
  ProfileCreatedModal,
  ProfileHideAccountModal,
  ProfileDeleteAccountModal,
  ProfileShowAccountModal,
  OnboardingWizard,
} from 'view/modals';

export const ProfileConfigContainer = memo(() => {
  return (
    <>
      <ProfileCreatedModal hideCloseButton />
      <ProfileHideAccountModal />
      <ProfileDeleteAccountModal />
      <ProfileShowAccountModal />
      <OnboardingWizard />
    </>
  );
});
